var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
import FadeIn from '../../../components/Animation/FadeIn';
import { ValidationString } from '../../../hooks/useValidation';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../../hooks/useUser';
import Button from '../../../components/Button';
import { ChevronLeft, Plus } from 'react-feather';
import { RoutePaths } from '../../../config/routes';
import classNames from 'classnames';
import { Shape2 } from '../../../components/CustomIcon';
import axiosInstance from '../../../config/axios';
import { api } from '../../../config/api';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import CardExperience from '../../../components/Card/Experience';
import Drawer from '../../../components/Drawer';
import ExperienceForm from '../../../components/Fields/Experience/Form';
import Heading from '../../../components/Typography/Heading';
import { deepEqual, pick } from '../../../utils/Objects';
import { serialize } from 'object-to-formdata';
import ModalBasic from '../../../components/Modal/Basic';
import { useSignOut } from 'react-auth-kit';
import { useAuth } from '../../../hooks/useAuth';
var DashboardExperience = function () {
    var _a;
    var navigate = useNavigate();
    var signOut = useSignOut();
    var isAuthenticated = useAuth().isAuthenticated;
    var _b = useState(), experience = _b[0], setExperience = _b[1];
    var _c = useState(), types = _c[0], setTypes = _c[1];
    var _d = useState(false), drawer = _d[0], setDrawer = _d[1];
    var _e = useState(false), modal = _e[0], setModal = _e[1];
    var _f = useState(), type = _f[0], setType = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = useUser(), getUserStorage = _h.getUserStorage, setUserStorage = _h.setUserStorage, removeUserStorage = _h.removeUserStorage;
    var _j = useState(), user = _j[0], setUser = _j[1];
    var _k = useForm({
        defaultValues: {
            experiences: user === null || user === void 0 ? void 0 : user.experiences,
        },
    }), setValue = _k.setValue, getValues = _k.getValues, reset = _k.reset;
    var handleDrawerClose = function () {
        setDrawer(false);
        setType(undefined);
        setExperience(undefined);
    };
    var handleDrawerBack = function () {
        type ? setType(undefined) : setDrawer(false);
    };
    var handleExperienceAdd = function (experienceObject) {
        var initialValues = getValues('experiences') || [];
        setValue('experiences', __spreadArray(__spreadArray([], initialValues, true), [experienceObject], false));
    };
    var handleExperienceUpdate = function (experienceObject) {
        var initialValues = getValues('experiences') || [];
        var updatedValues = initialValues.map(function (previousExperience) {
            if (deepEqual(previousExperience, experience)) {
                return experienceObject;
            }
            return previousExperience;
        });
        setValue('experiences', updatedValues);
    };
    var handleExperienceDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var initialValues, updatedValues, formData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initialValues = getValues('experiences') || [];
                    updatedValues = initialValues.filter(function (el) { return !deepEqual(el, experience); });
                    setValue('experiences', updatedValues);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(pick(getValues(), 'experiences'), {
                        indices: true,
                        allowEmptyArrays: true,
                    });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    reset(response.data);
                    toast.success("L'expérience a bien été suprimée");
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleFormError(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setModal(false);
                    handleDrawerClose();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    experience ? handleExperienceUpdate(data) : handleExperienceAdd(data);
                    if (deepEqual(pick(getValues(), 'experiences'), pick(user, 'experiences')))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(pick(getValues(), 'experiences'), { indices: true });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    reset(response.data);
                    toast.success('Vos expériences ont bien été mises à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    handleFormError(error_2);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    handleDrawerClose();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var openDrawerWithData = function (experience) {
        setExperience(experience);
        setType(experience.type);
        setDrawer(true);
    };
    var handleUser = function (user) {
        setUserStorage(user);
        setUser(user);
    };
    var handleSessionExpired = function () {
        if (isAuthenticated())
            return;
        removeUserStorage();
        signOut();
        navigate(RoutePaths.SIGN_IN, { replace: true, state: { expiredSession: true } });
    };
    var handleFormError = function (error) {
        var _a;
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
            handleSessionExpired();
        }
        else {
            toast.error(ValidationString.PROFILE);
        }
    };
    useEffect(function () {
        //Récupération des infos de l'utilisateur
        if (!getUserStorage()) {
            axiosInstance
                .get(api.user.get)
                .then(function (response) {
                handleUser(response.data);
                reset(response.data);
            })
                .catch(function (error) {
                handleFormError(error);
            });
        }
        else {
            handleUser(getUserStorage());
            reset(getUserStorage());
        }
        //Récupération des types
        axiosInstance
            .get(api.experiences.types)
            .then(function (response) {
            setTypes(response.data);
        })
            .catch(function (error) {
            console.log(error);
        });
    }, []);
    if (!user)
        return null;
    return (<FadeIn>
      <div className="container">
        <div className="my-10 lg:my-12">
          <Button icon={ChevronLeft} type="inline" side="start" onClick={function () {
            navigate(RoutePaths.DASHBOARD);
        }}>
            Précédent
          </Button>
          <div className="relative mt-2 min-h-[60vh] pt-6 pb-12 lg:pb-28 max-sm:pl-14 sm:max-lg:pl-24">
            <div className="lg:w-5/12">
              <div className={classNames('flex w-full cursor-pointer items-center rounded-lg', 'border border-dashed border-gray-400 bg-gray-100', 'p-4 transition-opacity md:hover:opacity-60 lg:p-6')} onClick={function () { return setDrawer(true); }}>
                <Plus size={24} className="mr-2"/>
                <span className="text-base font-medium">Ajouter une expérience</span>
              </div>
            </div>

            {user.experiences && (<div className="mt-6 flex flex-col justify-between md:mt-8 lg:flex-row-reverse lg:flex-wrap max-lg:gap-10">
                {(_a = user.experiences) === null || _a === void 0 ? void 0 : _a.map(function (experience, index) { return (<CardExperience className={classNames('w-full lg:w-5/12', index % 2 == 1 && 'lg:mt-28')} experience={experience} onClick={function () { return openDrawerWithData(experience); }} key={index} background={false}/>); })}
              </div>)}
            <div className="absolute top-0 left-0 flex h-full flex-col items-center lg:left-1/2 lg:-translate-x-1/2 max-lg:pt-16">
              <Shape2 size={90} className="max-sm:h-8 max-sm:w-8 sm:max-lg:h-10 sm:max-lg:w-10"/>
              <span className="w-0 flex-1 border-l border-dashed border-secondary-01-light"/>
              <Shape2 size={90} className="max-sm:h-8 max-sm:w-8 sm:max-lg:h-10 sm:max-lg:w-10"/>
            </div>
          </div>
        </div>

        <Drawer handleClose={handleDrawerClose} handleBack={handleDrawerBack} open={drawer} className="max-sm:top-auto max-sm:bottom-0 max-sm:h-auto max-sm:max-h-[100%]">
          {type ? (<FadeIn>
              <ExperienceForm type={type} defaultValues={experience} onDelete={function () { return setModal(true); }} removable={!!experience} onSubmit={function (data) { return onSubmit(data); }}/>
            </FadeIn>) : (<div className="px-drawer-lg pb-8">
              <Heading level={2} type="h6">
                Allons-y ! Quel type d’expérience voulez-vous ajouter&nbsp;?
              </Heading>
              {(types === null || types === void 0 ? void 0 : types.length) && (<div className="mt-4 grid grid-cols-2 gap-4 sm:mt-9">
                  {types.map(function (type) { return (<div key={type.name} className="flex-center min-h-12 sm:min-h-20 cursor-pointer rounded-lg border border-gray-300 p-4 text-center transition-opacity hover:opacity-60" onClick={function () { return setType(type); }}>
                      {type.title}
                    </div>); })}
                </div>)}
            </div>)}
        </Drawer>

        <ModalBasic handleClose={function () { return setModal(false); }} open={modal} className="max-md:mx-4 max-md:h-auto">
          <div className="flex flex-col items-center gap-10 max-md:mb-6">
            <Heading level={2} type="h5" className="text-center">
              Souhaitez-vous vraiment supprimer cette expérience&nbsp;?
            </Heading>
            <div className="flex gap-6">
              <Button onClick={handleExperienceDelete} type="outlined" alert="danger">
                Supprimer
              </Button>
              <Button onClick={function () { return setModal(false); }} type="outlined">
                Annuler
              </Button>
            </div>
          </div>
        </ModalBasic>
      </div>
    </FadeIn>);
};
export default DashboardExperience;
